import React, { useEffect, useReducer, useState, useRef } from "react";
import { hot } from "react-hot-loader/root";
import { Col, ListGroup, Tab, Row } from "react-bootstrap";
//import Table from "../shared/Table";
//import TableRow from "../shared/Row";
import PhoneCallsDashboardReducer from "./PhoneCallsDashboardReducer";
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  MdClose,
  MdSearch,
  MdAccountCircle,
  MdOutbox,
  MdInbox,
  MdAddCall,
  MdSort,
} from "react-icons/md";
import * as API from "../api";
import * as CallChannel from "../channels/call_channel";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function PhoneCallsDashboard() {
  const [state, dispatch] = useReducer(PhoneCallsDashboardReducer, { completedCalls: null, calls: null, settings: null });
  const stateRef = useRef(state);
  let [calls, setCalls] = useState(stateRef.current ? stateRef.current.calls : []);
  let [weekendsEnabled, setWeekendsEnabled] = useState(stateRef.current && stateRef.current.settings ? stateRef.current.settings.weekends_enabled : false);
  let [afterhoursEnabled, setAfterhoursEnabled] = useState(stateRef.current && stateRef.current.settings ? stateRef.current.settings.afterhours_enabled : false);
  let [lastSavedBy, setLastSavedBy] = useState(stateRef.current && stateRef.current.settings ? stateRef.current.settings.last_saved_by : null);
  let [completedCalls, setCompletedCalls] = useState(stateRef.current ? stateRef.current.completedCalls : []);
  let [loading, setLoading] = useState(false);

  const wrapUpCallHandler = (call) => {
    let currentState = stateRef.current;

    currentState.calls.pop((el) => {
      return el.id == call.id;
    });

    if(currentState.completedCalls) {
      currentState.completedCalls.push(call);
    }

    setCalls(currentState.calls);
    setCompletedCalls(currentState.completedCalls);
    return dispatch({
      type: "set_calls",
      calls: currentState.calls,
      completedCalls: currentState.completedCalls,
      settings: currentState.settings
    });
  };

  const callCreatedHandler = (call) => {
    let currentState = stateRef.current;
    currentState.calls.push(call);
    setCalls(currentState.calls);
    dispatch({
      type: "set_calls",
      calls: currentState.calls,
      completedCalls: currentState.completedCalls,
      settings: currentState.settings
    });
  }

  const SOCKET_EVENTS = {
    'wrap-up-call': {
      event_type: 'wrap-up-call',
      handler: wrapUpCallHandler
    },
    'call-created': {
      event_type: 'call-created',
      handler: callCreatedHandler
    },
  };
  // Update the ref whenever state changes
  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      if(calls == null) {
        let response = await API.getPhoneCalls();
        if (response) {
          CallChannel.createCallSubscription(
            response['settings'],
            stateRef,
            SOCKET_EVENTS
          );
          setCalls(response['calls']);
          setCompletedCalls(response['completed_calls']);
          setWeekendsEnabled(response['settings']['weekends_enabled']);
          setAfterhoursEnabled(response['settings']['afterhours_enabled']);
          setLastSavedBy(response['settings']['last_saved_by']);
          setLoading(false);
          dispatch({
            type: "set_calls",
            calls: response['calls'],
            completedCalls: response['completed_calls'],
            settings: response['settings']
          });
        }
      }
    };
    fetchData();
  }, []);

  const saveCallCenterSettings = async (afterhoursEnabled, weekendsEnabled) => {
    let response = await API.saveCallCenterSettings(afterhoursEnabled, weekendsEnabled);

    if (response) {
      return response;
    }
  };

  const CallComponent = (props) => {
    return (
      <>
        <TableContainer>
          <h4>
            <i className='fa fa-phone m-r-lg blue-text'></i>
            {props.title}
          </h4>
          <Table className="table">
            <TableHead>
              <TableRow> {props.headers} </TableRow>
            </TableHead>
            <TableBody>
              {props.children}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };

  const OngoingDurationComponent = (props) => {
    const [time, setTime] = useState(Math.round(Date.now()/1000));
    let createdAtTime = Math.round(Date.parse(props.createdAt)/1000);
    useEffect(() => {
      const intervalId = setInterval(() => {
        setTime(Math.round(Date.now()/1000));
      }, 1000);

      return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    let secondsDiff = time - createdAtTime;
    let str, colorClass;
    if (secondsDiff > 60 && secondsDiff < 3600) {
      let mins = Math.round(secondsDiff/60);
      str = `${  mins } mins`;
      if (mins > 15) {
        colorClass = 'bold red';
      } else {
        colorClass = 'bold green';
      }
    } else if (secondsDiff > 3600 && secondsDiff < 86400) {
      str = `${  Math.round(secondsDiff/3600) } hours`;
      colorClass = 'bold red';
    } else if(secondsDiff > 86400) {
      str = `${ Math.round(secondsDiff/86400) } days`;
      colorClass = 'bold red';
    } else {
      str = `${ secondsDiff } seconds`;
      colorClass = 'bold green';
    }

    return (
      <div>
        <span className={`${ colorClass }-text blink_me`}>{str}</span>
      </div>
    );
  }
  return(<>
    <div className="panel container">
      <div className="panel-body">
        <Tab.Container id="call-center-settings-form" defaultActiveKey="first">
          <Row className="tasks-search-row">
            <Col xs={12} md={3}>
              <h3><i className='fa blue-text fa-cog m-l-lg'></i> Call Center Settings</h3>
              <hr />
              {loading == true &&
                  <>
                    <h3><i className='fa fa-spinner fa-spin'></i> Loading..</h3>
                  </>
              }
              {loading != true && (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        onChange={(event) => {
                          setAfterhoursEnabled(event.target.checked);
                        }}
                        checked={afterhoursEnabled}
                        value={afterhoursEnabled}
                      />
                      }
                    label="After Hours Enabled?"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        onChange={(event) => {
                          setWeekendsEnabled(event.target.checked);
                        }}
                        checked={weekendsEnabled}
                        value={weekendsEnabled}
                      />
                    }
                    label="Weekend Enabled?"
                  />
                  <Button
                    onClick={
                      async () => {
                        let response = await saveCallCenterSettings(afterhoursEnabled, weekendsEnabled)

                        if(response) {
                          alert('Saved!');
                        }
                      }
                    }
                  variant="contained">Save</Button>
                  <br />
                  {lastSavedBy && (
                    <i>Last saved by { lastSavedBy }</i>) }
                </FormGroup>
              )}
            </Col>
          </Row>
        </Tab.Container>
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row className="tasks-search-row">
            <Col md={12}>
              <h3><i className='fa blue-text fa-list m-l-lg'></i> Call Monitoring</h3>
              <hr />
              {loading == true &&
                  <>
                    <h3><i className='fa fa-spinner fa-spin'></i> Loading..</h3>
                  </>
              }
              {
                loading != true && calls && (
                  <CallComponent
                    title={'Ongoing Phone Calls'}
                    headers={
                      [
                        <TableCell key={0}>Call ID</TableCell>,
                        <TableCell key={1}>Duration</TableCell>,
                        <TableCell key={2}>From</TableCell>,
                        <TableCell key={3}>To</TableCell>,
                        <TableCell key={4}>Direction</TableCell>,
                        <TableCell key={5}>Patient</TableCell>,
                        <TableCell key={6}>Agent</TableCell>,
                        <TableCell key={7}>Status</TableCell>,
                        <TableCell key={8}>Outcome</TableCell>,
                        <TableCell key={9}>Task</TableCell>

                      ]
                    }
                    children={calls.map((el, i) => {
                        return (
                          <TableRow
                            key={i}
                          >
                            <TableCell> {el.id}</TableCell>
                            <TableCell>
                              <OngoingDurationComponent
                                createdAt={el.created_at}
                              />
                            </TableCell>
                            <TableCell> {el.from}</TableCell>
                            <TableCell> {el.to}</TableCell>
                            <TableCell> {el.direction}</TableCell>
                            <TableCell>
                              { el.patient_id && (
                                <a href={`/physicians/patient_info/${el.patient_id}`}>
                                  {el.patient}
                                </a>
                              )}
                            </TableCell>
                            <TableCell> {el.support_agent}</TableCell>
                            <TableCell> <i className='fa fa-circle green-text'></i></TableCell>
                            <TableCell> {el.outcome}</TableCell>
                            <TableCell>
                              <a href={`physicians/tasks/item/${ el.task_id }`}>
                                Task
                              </a>
                            </TableCell>
                          </TableRow>
                        )
                      })
                    }
                  />
                )
              }
              {
                loading != true && completedCalls && (
                  <CallComponent
                    title={'Completed Phone Calls'}
                    headers={
                      [
                        <TableCell key={0}>Call ID</TableCell>,
                        <TableCell key={1}>Completed On</TableCell>,
                        <TableCell key={2}>From</TableCell>,
                        <TableCell key={3}>To</TableCell>,
                        <TableCell key={4}>Direction</TableCell>,
                        <TableCell key={5}>Patient</TableCell>,
                        <TableCell key={6}>Agent</TableCell>,
                        <TableCell key={7}>Status</TableCell>,
                        <TableCell key={8}>Outcome</TableCell>,
                        <TableCell key={9}>Task</TableCell>

                      ]
                    }
                    children={completedCalls.map((el, i) => {
                        return (
                          <TableRow
                            key={i}
                          >
                            <TableCell> {el.id}</TableCell>
                            <TableCell>{ el.completed_on} </TableCell>
                            <TableCell> {el.from}</TableCell>
                            <TableCell> {el.to}</TableCell>
                            <TableCell> {el.direction}</TableCell>
                            <TableCell>
                              { el.patient_id && (
                                <a href={`/physicians/patient_info/${el.patient_id}`}>
                                  {el.patient}
                                </a>
                              )}
                            </TableCell>
                            <TableCell> {el.support_agent}</TableCell>
                            <TableCell> <i className='fa fa-circle red-text'></i></TableCell>
                            <TableCell> {el.outcome}</TableCell>
                            <TableCell>
                              <a href={`physicians/tasks/item/${ el.task_id }`}>
                                Task
                              </a>
                            </TableCell>
                          </TableRow>
                        )
                      })
                    }
                  />
                )
              }
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </div>
  </>);
}

export default hot(PhoneCallsDashboard);
